import { IconMinus, IconPlus } from '@xing-com/icons';
import { Slider } from '@xing-com/slider';

import { Styled } from './zoom-range-input.styles';

type ZoomRangeInputProps = {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (zoom: number) => void;
};

export const ZoomRangeInput: React.FC<ZoomRangeInputProps> = ({
  value,
  min,
  max,
  step,
  onChange,
}) => {
  return (
    <Styled.ImageCropperZoomContainer>
      <Styled.ImageCropperControlButton
        data-testid="article-editor-zoom-range-input-minus-button"
        icon={IconMinus}
        onClick={() => {
          const newZoom = value - step;

          if (newZoom >= min) {
            onChange(newZoom);
          } else {
            onChange(min);
          }
        }}
        disabled={value <= min}
      />

      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e, value) => {
          e.preventDefault();
          // oxlint-disable-next-line typescript/consistent-type-assertions
          onChange(value as number);
        }}
      />

      <Styled.ImageCropperControlButton
        data-testid="article-editor-zoom-range-input-plus-button"
        icon={IconPlus}
        onClick={() => {
          const newZoom = value + step;
          if (newZoom <= max) {
            onChange(newZoom);
          } else {
            onChange(max);
          }
        }}
        disabled={value >= max}
      />
    </Styled.ImageCropperZoomContainer>
  );
};
